import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'timeConverter',
  pure: false
})
export class TimeConverterPipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  transform(value: number, unit: 'mins' | 'days'): string {
    if (value === undefined || value === null || value === 0) return `0 ${this.translate.instant('CARS.min')}`;

    // Portiamo tutto in minuti per avere la massima precisione nel calcolo
    let totalMinutes = unit === 'days' ? value * 1440 : value;

    const minsInYear = 525600;
    const minsInDay = 1440;
    const minsInHour = 60;

    let years = Math.floor(totalMinutes / minsInYear);
    let remainingMins = totalMinutes % minsInYear;

    let days = Math.floor(remainingMins / minsInDay);
    remainingMins %= minsInDay;

    let hours = Math.floor(remainingMins / minsInHour);
    remainingMins %= minsInHour;

    let parts: string[] = [];

    // Anni
    if (years > 0) {
      parts.push(`${years} ${this.translate.instant(years === 1 ? 'CARS.anno' : 'CARS.anni')}`);
    }

    // Giorni
    if (days > 0) {
      parts.push(`${days} ${this.translate.instant(days === 1 ? 'CARS.giorno' : 'CARS.giorni')}`);
    }

    // Ore
    if (hours > 0) {
      parts.push(`${hours} ${this.translate.instant(hours === 1 ? 'CARS.ora' : 'CARS.ore')}`);
    }

    // Minuti (mostrati solo se avanzano o se il valore totale era piccolissimo)
    if (remainingMins > 0 || parts.length === 0) {
      parts.push(`${remainingMins} ${this.translate.instant('CARS.min')}`);
    }

    // Unisce tutto con una virgola (es: "1 anno, 6 ore")
    return parts.join(', ');
  }
}
